import { redirect2Mobile } from './device';

const defalutWidth = 1920; // 默认宽度
let defalutFontSize = 100; // 默认字体大小

const minWidth = 1200; // 最小宽度
const maxWidth = 1920; // 最大宽度
const defalueScale = 1; // 默认比例关系

// 最大高度
const maxHeight = 1080;
// 高宽比  1080 / 1920
const widthHeightRatio = maxHeight / maxWidth;
// 最小高度
const minHeight = minWidth * widthHeightRatio;

const html = document.querySelector('html');

export const getRootFontSize = () => {
  let getWidth = window.innerWidth; // 获取屏幕的宽度
  let getHeight = window.innerHeight; // 获取屏幕的高度

  const currentRatio = getHeight / getWidth;

  // 属于非常宽，但是非常矮的屏幕. 则根据当前高度换算出 1920*1080 比例的宽度
  if (currentRatio < widthHeightRatio) {
    getWidth = getHeight / widthHeightRatio;
  }

  if (getWidth < minWidth) {
    getWidth = minWidth;
  } else if (getWidth > maxWidth) {
    getWidth = maxWidth;
  }

  const currentScale = getWidth / defalutWidth; // 计算当前的屏幕大小和默认宽度之间的比例

  const currentFontSize = (currentScale / defalueScale) * defalutFontSize;

  return currentFontSize;
};

export function setScrollbarVar() {
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
}

// 设置根字体大小
const flexView = () => {
  const resizeFunc = () => {
    const currentFontSize = getRootFontSize();
    html!.style.fontSize = currentFontSize + 'px';

    window['rootFontSize'] = currentFontSize;

    redirect2Mobile();
  };
  resizeFunc();

  window.addEventListener('resize', resizeFunc);
};

export default flexView;
